import {
  ChakraBox,
  ChakraHStack,
  ChakraText,
  EquipUIFireflyV2Theme,
  EquipUITheme,
  FlagOutline,
} from '@equip.health/ui';

import { formatObservationDate, getHistoryChangeText } from './utils';
import { ParsedActivityEvent, PatientVitalsTabs } from '../../constants';

const { label: labelStyle, labelBold } = EquipUITheme.typography;
const { neutral } = EquipUIFireflyV2Theme.colors;

type HistoryItemProps = {
  historyEvent: ParsedActivityEvent;
  id: string;
  tab: PatientVitalsTabs;
};

const HistoryItem = ({ historyEvent, id, tab }: HistoryItemProps) => {
  const { updatedAt, updatedBy } = historyEvent;
  return (
    <ChakraHStack id={id} spacing="16px">
      <ChakraBox>
        <FlagOutline fill={neutral.tertiary} height="16px" width="16px" />
      </ChakraBox>
      <ChakraText
        {...labelBold}
        color="neutral.primary"
        id={`${id}__change-description`}
      >
        {getHistoryChangeText(historyEvent, tab)}
      </ChakraText>
      <ChakraText
        {...labelStyle}
        color="neutral.secondary"
        id={`${id}__updated-by`}
      >
        by <span style={{ fontWeight: 700 }}>{updatedBy}</span>
      </ChakraText>
      <ChakraText
        {...labelStyle}
        color="neutral.secondary"
        id={`${id}__updated-at`}
      >
        {formatObservationDate(updatedAt)}
      </ChakraText>
    </ChakraHStack>
  );
};

export default HistoryItem;
